import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
      
      <p class="mb-3">
        Мне подарили прекрасную розу. 
        Она была прозрачна, как хрусталь, и вся переливалась и сияла разными цветами: красным, синим, фиолетовым… 
        В восторге от её красоты, я бережно обняла её ладонями и спрятала на груди, ближе к сердцу. 
      </p>
      
      <p class="mb-3">
        Но скоро пришло странное чувство, будто что-то холодное прикасается к моей груди, а потом я почувствовала, как ледяные струи текут по телу. 
        В изумлении я взглянула вниз – и увидела только большое мокрое пятно, так неприятно холодящее кожу.
      </p>
      
      <p class="mb-3">
        Роза была изо льда.
      </p>

    </div>
    `
  )
}

const itemName = {
  rus: `Прекрасная роза`
}

const itemDate = {
  rus: `15 марта 2018 г.`
}

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;